// Авто-высота textarea в канвасе: элемент рисуется без рамок и скроллбара
// (`overflow-hidden`), поэтому высоту приходится мерить руками.

/** Подогнать высоту под содержимое. Сброс в `auto` обязателен: без него
 *  `scrollHeight` вернёт уже растянутую высоту, и поле никогда не сожмётся.
 *
 *  ВЫЗЫВАТЬ ТОЛЬКО ИЗ ИНЛАЙНОВОГО ref-колбэка (`ref={(el) => autoGrowTextArea(el)}`).
 *  Стабильную ссылку React считает неизменной и ref не переприкрепляет — высота
 *  застывает с маунта, и `overflow-hidden` режет текст при любом изменении не с
 *  клавиатуры: смене языка, undo, правке из панели настроек. Это уже чинили. */
export const autoGrowTextArea = (el: HTMLTextAreaElement | null): void => {
  if (!el) return
  el.style.height = 'auto'
  el.style.height = `${el.scrollHeight}px`
}
